import semver from 'semver'

import Environment from '../utils/environment'
import { bridge_getDeviceModel } from './bridgeCalls/VNWebSDKDataSend'
import { DEVICE_MODEL, CFD_HARDWARE, HANDHELD_DEVICES } from '../VNMode/Utils'

/**
 * Determine if a feature meets the minimum android SDK version.
 * @param {String} androidSDKVersion - the Android SDK Version from VNAndroidSDK - version state
 * @param {Strings} minimumVersion - The minimum android sdk sem version.
 * @returns {Boolean} - Returns true if compatible, false otherwise (ignores pre-releases)
 */
export const isSDKCompatible = (androidSDKVersion, minimumVersion) => {
  if (!androidSDKVersion?.length) return false

  // include prerelease versions (i.e. '2.18.0-qa6')
  const apkVersion = androidSDKVersion.split?.('-')[0]

  return semver.gte(apkVersion, minimumVersion, { includePrerelease: true })
}

/**
 * Internal method. Parse a boolean URL parameter.
 * Make sure that this is used at the correct time. It has to be used when the parameter is set in
 * the URL, not any URL that the web application is redirected to. Device login is a good entry
 * point to use this method.
 * @param {String} paramName The name of the URL parameter to parse.
 * @returns The boolean value of the URL parameter.
 */
const parseBooleanUrlParam = (paramName, parseNullAsFalse = true) => {
  const urlParams = new URLSearchParams(window.location.search)
  const booleanParamValue = urlParams.get(paramName)

  if (booleanParamValue && booleanParamValue === 'true') return true
  return parseNullAsFalse ? false : booleanParamValue === 'false' ? false : booleanParamValue
}

export const isCFDMode = () => {
  if (CFD_HARDWARE.includes(bridge_getDeviceModel())) return true

  return parseBooleanUrlParam('cfd')
}

/**
 * Summit is determined by APK version. The URL param is largely kepft for web testing.
 * @returns {Boolean} true if summit mode, false otherwise
 */
export const isSummitMode = () => {
  return parseBooleanUrlParam('summit')
}

export const isRunningOnAndroid = () => {
  if (window.VN_DATA_BRIDGE !== undefined) return true
  if (window?.navigator?.userAgent?.includes('Android')) return true

  return parseBooleanUrlParam('apk')
}

export const isTestMode = () => {
  return (Environment.app.isDevelopment || Environment.app.isQA) && !isRunningOnAndroid()
}

export const isProdBrowser = () => {
  return !Environment.app.isDevelopment && !Environment.app.isQA && !isRunningOnAndroid()
}

// eDCC means E700 in Roman numerals.
export const isE700Device = () => {
  if (bridge_getDeviceModel() === DEVICE_MODEL.E700) return true

  return parseBooleanUrlParam('eDCC', false)
}

// eDCC means E700 in Roman numerals.
export const isHandheldDevice = () => {
  const deviceModel = bridge_getDeviceModel()

  return HANDHELD_DEVICES.includes(deviceModel)
}

export const isWorkstationDevice = () => {
  if (bridge_getDeviceModel() === DEVICE_MODEL.L1400) return true
  if (bridge_getDeviceModel() === DEVICE_MODEL.WEB) return true

  return false
}
